import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { ProductVisual } from './ProductVisual';
import { useCart } from '../contexts/CartContext';
import { formatPrice } from '../utils/currency';
import type { Product } from '../types/shop';
type ProductCardProps = {
  product: Product;
};
export function ProductCard({
  product
}: ProductCardProps) {
  const {
    addItem
  } = useCart();
  const comingSoon = product.status === 'coming-soon';
  const needsOption = Boolean(product.option);
  const href = comingSoon ? '/shop#watch' : `/shop/${product.slug}`;
  return <article className="group relative flex h-full flex-col" data-id="element-341" data-mp="td1mp988f8dj">
      <div className="relative" data-id="element-342" data-mp="yce7lofjm5dh">
        <Link to={href} aria-label={product.name} className="block" data-id="element-343" data-mp="ycmn7o31vosd">
          <ProductVisual product={product} className="aspect-square" imgClassName="transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-344" data-mp="2v4o6oqtpi30i" />
        </Link>
        {comingSoon && <span className="t-label absolute left-3 top-3 bg-white px-2.5 py-1 text-[0.6rem] text-charcoal" data-id="element-345" data-mp="3lrvs582cq6zp">Coming soon</span>}
        <div className="absolute inset-x-3 bottom-3 translate-y-1 opacity-0 transition-[opacity,transform] duration-200 ease-out group-focus-within:translate-y-0 group-focus-within:opacity-100 group-hover:translate-y-0 group-hover:opacity-100 [@media(hover:none)]:translate-y-0 [@media(hover:none)]:opacity-100" data-id="element-346" data-mp="3gy11tls8qtrn">
          {comingSoon ? <Link to={href} className="t-label flex h-11 w-full items-center justify-center bg-white text-[0.66rem] text-charcoal hover:bg-charcoal hover:text-white" data-id="element-347" data-mp="4i7adwa0rp8a">
              Join the waitlist
            </Link> : needsOption ? <Link to={href} className="t-label flex h-11 w-full items-center justify-center bg-white text-[0.66rem] text-charcoal hover:bg-charcoal hover:text-white" data-id="element-348" data-mp="3qpp128v1hf3o">
              Choose {product.option?.label.toLowerCase()}
            </Link> : <button type="button" onClick={() => addItem(product.id)} className="t-label flex h-11 w-full items-center justify-center gap-2 bg-white text-[0.66rem] text-charcoal transition-colors duration-150 hover:bg-charcoal hover:text-white" data-id="element-349" data-mp="2grp9i8rjksxg">
              <PlusIcon aria-hidden="true" strokeWidth={1.25} className="h-3.5 w-3.5" data-id="element-350" data-mp="2cpaq9njynr5n" /> Quick add
            </button>}
        </div>
      </div>
      <div className="mt-4 flex flex-1 items-start justify-between gap-4" data-id="element-351" data-mp="1xzmmmfob4ger">
        <h3 className="t-label text-charcoal" data-id="element-352" data-mp="22th55fs6epc9">
          <Link to={href} className="hover:underline hover:underline-offset-4" data-id="element-353" data-mp="1p1b12s2as8t6">
            {product.name}
          </Link>
        </h3>
        <p className="shrink-0 text-[0.95rem] text-graphite" data-id="element-354" data-mp="1t361zvgbgk6f">
          {comingSoon ? 'Waitlist' : `${product.pricePrefix ? `${product.pricePrefix} ` : ''}${formatPrice(product.price)}`}
        </p>
      </div>
      <p className="mt-1 text-sm text-graphite" data-id="element-355" data-mp="1k151mppsdi0j">{product.categories[0]}</p>
    </article>;
}